module.exports = "<div class=\"usc-store\">\n  <div class=\"row no-gutters usc_table_bar\">&nbsp;</div>\n  <br/>\n  <div [class]=\"loading_class\">Change Password...</div>\n  <iframe id=\"ifHome\" [src]=\"url\" width=\"100%\" style=\"border: 0px;\" (load)=\"onload($event)\" [class]=\"display_class\"></iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-password/usc-password.component.html
// module id = ../../../../../src/app/components/usc-store/usc-password/usc-password.component.html
// module chunks = main